import { ApiResponse } from '../../domain/models/api';
import UserService from '../../domain/services/UserService';

export class ApiProxyService {
  private static instance: ApiProxyService;
  private userService: typeof UserService;

  private constructor() {
    this.userService = UserService;
  }

  /**
   * Singleton instance al
   */
  public static getInstance(): ApiProxyService {
    if (!ApiProxyService.instance) {
      ApiProxyService.instance = new ApiProxyService();
    }
    return ApiProxyService.instance;
  }

  /**
   * Şifre yenileme işlemini gerçekleştir
   * Bu istek UserService üzerinden yapılarak domain mantığı korunur
   * @param token Şifre yenileme token'ı
   * @param password Yeni şifre
   * @param email Kullanıcı email adresi (opsiyonel)
   */
  public async resetPassword(token: string, password: string, email?: string): Promise<ApiResponse<any>> {
    try {
      // UserService üzerinden şifre yenileme isteği
      return await this.userService.resetPassword(token, password, email);
    } catch (error: any) {
      console.error('Şifre yenileme isteği başarısız oldu:', error);

      // Hata yanıtı oluştur
      return {
        success: false,
        error: error.response?.data?.message || 'Şifre yenileme işlemi başarısız oldu.',
        statusCode: error.response?.status || 500
      };
    }
  }

  public async forgotPassword(email: string): Promise<ApiResponse<any>> {
    try {
      return await this.userService.forgotPassword(email);
    } catch (error: any) {
      console.error('Forgot password request failed:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to send password reset email.',
        statusCode: error.response?.status || 500
      };
    }
  }

  /**
   * Hesap doğrulama işlemini gerçekleştir
   * Bu istek UserService üzerinden yapılarak domain mantığı korunur
   * @param confirmationId Doğrulama ID'si
   */
  public async confirmAccount(confirmationId: string): Promise<ApiResponse<any>> {
    try {
      // UserService üzerinden hesap doğrulama isteği
      return await this.userService.confirmAccount(confirmationId);
    } catch (error: any) {
      console.error('Hesap doğrulama isteği başarısız oldu:', error);

      // Hata yanıtı oluştur
      return {
        success: false,
        error: error.response?.data?.message || 'Hesap doğrulama işlemi başarısız oldu.',
        statusCode: error.response?.status || 500
      };
    }
  }
}

// Singleton instance export et
export default ApiProxyService.getInstance();
 